<template>
  <div class="dashboard-stat-figures-block">
    <!-- <Tabs class="" :animated="false">
      <TabPane label="统计" name="guarantor"> -->
        <Row :gutter="16">
          <Col span="8">
            <div class="stat-figure-block">
              <div class="stat-figure-title">今日新增</div>
              <div class="stat-figure-text">
                <span v-if="stat.todayNewCount===null">-</span>
                <ICountUp v-else
                  class="stat-figure-data"
                  :delay="delay"
                  :endVal="formatDigit(stat.todayNewCount, '笔').digit"
                  :options="formatDigit(stat.todayNewCount, '笔').withDecimal?optionsWithDecimal:options"
                  @ready="onReady"
                />
                <span class="stat-figure-unit">{{ formatDigit(stat.todayNewCount, '笔').unit }}</span>
              </div>
            </div>
          </Col>
          <Col span="8">
            <div class="stat-figure-block">
              <div class="stat-figure-title">本月新增</div>
              <div class="stat-figure-text">
                <span v-if="stat.monthNewCount===null">-</span>
                <ICountUp v-else
                  class="stat-figure-data"
                  :delay="delay"
                  :endVal="formatDigit(stat.monthNewCount, '笔').digit"
                  :options="formatDigit(stat.monthNewCount, '笔').withDecimal?optionsWithDecimal:options"
                  @ready="onReady"
                />
                <span class="stat-figure-unit">{{ formatDigit(stat.monthNewCount, '笔').unit }}</span>
              </div>
            </div>
          </Col>
          <Col span="8">
            <div class="stat-figure-block">
              <div class="stat-figure-title">本年新增</div>
              <div class="stat-figure-text">
                <span v-if="stat.yearNewCount===null">-</span>
                <ICountUp v-else
                  class="stat-figure-data"
                  :delay="delay"
                  :endVal="formatDigit(stat.yearNewCount, '笔').digit"
                  :options="formatDigit(stat.yearNewCount, '笔').withDecimal?optionsWithDecimal:options"
                  @ready="onReady"
                />
                <span class="stat-figure-unit">{{ formatDigit(stat.yearNewCount, '笔').unit }}</span>
              </div>
            </div>
          </Col>
          <Col span="8">
            <div class="stat-figure-block">
              <div class="stat-figure-title">今日保额</div>
              <div class="stat-figure-text">
                <span v-if="stat.todayNewAmount===null">-</span>
                <ICountUp v-else
                  class="stat-figure-data"
                  :delay="delay"
                  :endVal="formatDigit(stat.todayNewAmount/100, '元').digit"
                  :options="formatDigit(stat.todayNewAmount/100, '元').withDecimal?optionsWithDecimal:options"
                  @ready="onReady"
                />
                <span class="stat-figure-unit">{{ formatDigit(stat.todayNewAmount/100, '元').unit }}</span>
              </div>
            </div>
          </Col>
          <Col span="8">
            <div class="stat-figure-block">
              <div class="stat-figure-title">本月保额</div>
              <div class="stat-figure-text">
                <span v-if="stat.monthNewAmount===null">-</span>
                <ICountUp v-else
                  class="stat-figure-data"
                  :delay="delay"
                  :endVal="formatDigit(stat.monthNewAmount/100, '元').digit"
                  :options="formatDigit(stat.monthNewAmount/100, '元').withDecimal?optionsWithDecimal:options"
                  @ready="onReady"
                />
                <span class="stat-figure-unit">{{ formatDigit(stat.monthNewAmount/100, '元').unit }}</span>
              </div>
            </div>
          </Col>
          <Col span="8">
            <div class="stat-figure-block">
              <div class="stat-figure-title">本年保额</div>
              <div class="stat-figure-text">
                <span v-if="stat.yearNewAmount===null">-</span>
                <ICountUp v-else
                  class="stat-figure-data"
                  :delay="delay"
                  :endVal="formatDigit(stat.yearNewAmount/100, '元').digit"
                  :options="formatDigit(stat.yearNewAmount/100, '元').withDecimal?optionsWithDecimal:options"
                  @ready="onReady"
                />
                <span class="stat-figure-unit">{{ formatDigit(stat.yearNewAmount/100, '元').unit }}</span>
              </div>
            </div>
          </Col>
        </Row>
        <div class="padding-top-10"></div>
        <Row :gutter="16">
          <Col span="12">
            <div class="stat-figure-block">
              <div class="stat-figure-title">累计保函</div>
              <div class="stat-figure-text">
                <span v-if="stat.totalCount===null">-</span>
                <ICountUp v-else
                  class="stat-figure-data large"
                  :delay="delay"
                  :endVal="formatDigit(stat.totalCount, '笔').digit"
                  :options="formatDigit(stat.totalCount, '笔').withDecimal?optionsWithDecimal:options"
                  @ready="onReady"
                />
                <span class="stat-figure-unit">{{ formatDigit(stat.totalCount, '笔').unit }}</span>
              </div>
            </div>
          </Col>
          <Col span="12">
            <div class="stat-figure-block">
              <div class="stat-figure-title">累计保额</div>
              <div class="stat-figure-text">
                <span v-if="stat.totalAmount===null">-</span>
                <ICountUp v-else
                  class="stat-figure-data large"
                  :delay="delay"
                  :endVal="formatDigit(stat.totalAmount/100, '元').digit"
                  :options="formatDigit(stat.totalAmount/100, '元').withDecimal?optionsWithDecimal:options"
                  @ready="onReady"
                />
                <span class="stat-figure-unit">{{ formatDigit(stat.totalAmount/100, '元').unit }}</span>
              </div>
            </div>
          </Col>
          <Col span="12">
            <div class="stat-figure-block">
              <div class="stat-figure-title">在保保函</div>
              <div class="stat-figure-text">
                <span v-if="stat.undergoingCount===null">-</span>
                <ICountUp v-else
                  class="stat-figure-data large"
                  :delay="delay"
                  :endVal="formatDigit(stat.undergoingCount, '笔').digit"
                  :options="formatDigit(stat.undergoingCount, '笔').withDecimal?optionsWithDecimal:options"
                  @ready="onReady"
                />
                <span class="stat-figure-unit">{{ formatDigit(stat.undergoingCount, '笔').unit }}</span>
              </div>
            </div>
          </Col>
          <Col span="12">
            <div class="stat-figure-block">
              <div class="stat-figure-title">在保保额</div>
              <div class="stat-figure-text">
                <span v-if="stat.undergoingAmount===null">-</span>
                <ICountUp v-else
                  class="stat-figure-data large"
                  :delay="delay"
                  :endVal="formatDigit(stat.undergoingAmount/100, '元').digit"
                  :options="formatDigit(stat.undergoingAmount/100, '元').withDecimal?optionsWithDecimal:options"
                  @ready="onReady"
                />
                <span class="stat-figure-unit">{{ formatDigit(stat.undergoingAmount/100, '元').unit }}</span>
              </div>
            </div>
          </Col>
        </Row>
      <!-- </TabPane>
    </Tabs> -->
  </div>
</template>

<script>
import ICountUp from 'vue-countup-v2'
export default {
  components: {
    ICountUp
  },
  data () {
    return {
      stat: {
        totalCount: null,
        totalAmount: null,
        totalDeposit: null,
        undergoingCount: null,
        undergoingAmount: null,
        undergoingDeposit: null,
        todayNewCount: null,
        todayNewAmount: null,
        todayNewDeposit: null,
        monthNewCount: null,
        monthNewAmount: null,
        monthNewDeposit: null,
        yearNewCount: null,
        yearNewAmount: null,
        yearNewDeposit: null
      },
      delay: 1000,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: '.',
        decimalPlaces: 0,
        prefix: '',
        suffix: ''
      },
      optionsWithDecimal: {
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: '.',
        decimalPlaces: 2,
        prefix: '',
        suffix: ''
      },
    }
  },
  mounted () {
    this.getDashboardStat()
  },
  methods: {
    formatDigit (digit, unit = '元') {
      if (digit / 100000000 >= 1) {
        return {
          digit: digit / 100000000,
          unit: `亿${unit}`,
          withDecimal: true
        }
      } else if (digit / 10000 >= 1) {
        return {
          digit: digit / 10000,
          unit: `万${unit}`,
          withDecimal: true
        }
      } else {
        return {
          digit,
          unit,
          withDecimal: false
        }
      }
    },
    getDashboardStat () {
      this.$Api.Statistics.dashboardStat()
      .catch(err => {
        this.$Message.error('获取数据出错' + err)
      })
      .then(res => {
        this.stat = res
      })
    },
    onReady1 (instance, CountUp) { // 
      instance.start()
      console.log(CountUp)
    },
    onReady () { // (instance, CountUp)
      // const that = this
      // instance.update(that.endVal + 100)
    },
  }
}
</script>

<style lang="less" scoped>
@font-face {
  font-family: LEDFont;
  src: url("/static/font/UnidreamLED.ttf");
  src: url("/static/font/UnidreamLED.woff") format("woff");
}
.stat-figure-block {
  // border: 2px solid @primaryColor;
  border-radius: 5px;
  background: @primaryColor;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 16px;
  padding: 5px;
  .stat-figure-title {
    font-size: 12px;
    text-align: left;
    color: #dfdfdf;
  }
  .stat-figure-text {
    // padding: 10px 0;
    text-align: center;
    // color: @primaryColor;
  }
  .stat-figure-data {
    font-size: 24px;
    font-family: LEDFont;
    margin: 0 5px;
    font-style: italic;
    &.large {
      font-size: 36px;
    }
  }
}
</style>